import {
  GET_MY_APPROVAL_OVERTIME_REQUESTS_ERROR,
  GET_MY_APPROVAL_OVERTIME_REQUESTS_PENDING,
  GET_MY_APPROVAL_OVERTIME_REQUESTS_SUCCESS,
  GET_MY_APPROVAL_TIME_ADJUSTMENT_REQUESTS_ERROR,
  GET_MY_APPROVAL_TIME_ADJUSTMENT_REQUESTS_PENDING,
  GET_MY_APPROVAL_TIME_ADJUSTMENT_REQUESTS_SUCCESS,
  SET_APPROVAL_DROPDOWN_FILTER_COUNTRY,
  SET_MY_APPROVAL_OVERTIME_REQUESTS,
  SET_MY_APPROVAL_TIME_ADJUSTMENT_REQUESTS,
} from './constants';

const INIT_STATE = {
  overTimeApprovalRequests: [],
  timeAdjustmentApprovalRequests: [],
  isGetOverTimeApprovalRequests: false,
  isGetTimeAdjustmentApprovalRequests: false,
  selectedCountry: {},
};

export default (localState = INIT_STATE, action) => {
  switch (action.type) {
    case GET_MY_APPROVAL_OVERTIME_REQUESTS_PENDING: {
      return {
        ...localState,
        isGetOverTimeApprovalRequests: true,
      };
    }
    case GET_MY_APPROVAL_OVERTIME_REQUESTS_SUCCESS: {
      return {
        ...localState,
        isGetOverTimeApprovalRequests: false,
      };
    }
    case GET_MY_APPROVAL_OVERTIME_REQUESTS_ERROR: {
      return {
        ...localState,
        isGetOverTimeApprovalRequests: false,
      };
    }
    case SET_MY_APPROVAL_OVERTIME_REQUESTS: {
      return {
        ...localState,
        overTimeApprovalRequests: action.payload,
      };
    }
    case GET_MY_APPROVAL_TIME_ADJUSTMENT_REQUESTS_PENDING: {
      return {
        ...localState,
        isGetTimeAdjustmentApprovalRequests: true,
      };
    }
    case GET_MY_APPROVAL_TIME_ADJUSTMENT_REQUESTS_SUCCESS: {
      return {
        ...localState,
        isGetTimeAdjustmentApprovalRequests: false,
      };
    }
    case GET_MY_APPROVAL_TIME_ADJUSTMENT_REQUESTS_ERROR: {
      return {
        ...localState,
        isGetTimeAdjustmentApprovalRequests: false,
      };
    }
    case SET_MY_APPROVAL_TIME_ADJUSTMENT_REQUESTS: {
      return {
        ...localState,
        timeAdjustmentApprovalRequests: action.payload,
      };
    }
    case SET_APPROVAL_DROPDOWN_FILTER_COUNTRY: {
      return {
        ...localState,
        selectedCountry: action.payload,
      };
    }
    default:
      return { ...localState };
  }
};
